/**
 * SectionPlaceholder — pantalla de sección aún sin contenido real.
 * Usada por las sub-secciones nuevas de la navegación (Categorías, Ciudades,
 * Historial) para que el árbol de nav sea navegable y coherente mientras se
 * construye su contenido definitivo.
 */
interface SectionPlaceholderProps {
  title: string;
  subtitle: string;
}

export function SectionPlaceholder({ title, subtitle }: SectionPlaceholderProps): JSX.Element {
  return (
    <div className="container-fc flex min-h-[60vh] flex-col items-center justify-center gap-3 py-16 text-center">
      <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v4M12 16h.01" />
        </svg>
      </span>
      <h1 className="text-2xl font-bold text-neutral-900">{title}</h1>
      <p className="max-w-md text-sm text-neutral-500">{subtitle}</p>
    </div>
  );
}
